import { render, staticRenderFns } from "./onlitdet.vue?vue&type=template&id=62b71a89&scoped=true&"
import script from "./onlitdet.vue?vue&type=script&lang=js&"
export * from "./onlitdet.vue?vue&type=script&lang=js&"
import style0 from "./onlitdet.vue?vue&type=style&index=0&id=62b71a89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b71a89",
  null
  
)

export default component.exports